export default __webpack_public_path__ + "static/media/Punto_04_Finocchietti_FRA_Def.d60f1bb1.aac";